import { useState } from "react";
import { Button, TextField } from "@mui/material";
import unipetroLogo from "../../images/Grupo Logo Unipetro pequeno.jpg";

import "./ResetPassword.scss";
import { resetPassword } from "../../services/password-service";
import { useNavigate } from "react-router-dom";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    const data = {
      email,
      token,
      newPassword: password,
    };

    const result = await resetPassword(data);
    if (result.name === "AxiosError")
      return alert("Algo deu errado. Tente novamente.");
    alert("Senha atualizada com sucesso.");
  }

  return (
    <div className="reset-password-wrapper">
      <div className="reset-password-wrapper__container">
        <img src={unipetroLogo} alt="logo" />
        <form onSubmit={handleSubmit}>
          <p>
            Para concluir a solicitação, favor digitar o email novamente, token
            recebido por email e a nova senha.
          </p>

          <TextField
            label="Email"
            name="email"
            onChange={(e) => setEmail(e.target.value)}
            inputProps={{
              autoComplete: "off",
            }}
          />

          <TextField
            label="Token"
            name="token"
            onChange={(e) => setToken(e.target.value)}
            inputProps={{
              autoComplete: "off",
            }}
          />

          <TextField
            label="Nova Senha"
            name="new-password"
            onChange={(e) => setPassword(e.target.value)}
            inputProps={{
              autoComplete: "off",
            }}
          />

          <Button type="submit" variant="contained">
            Trocar a senha
          </Button>

          <Button onClick={() => navigate('/')} type="submit" variant="outlined">
            Voltar para a página principal
          </Button>
        </form>
      </div>
    </div>
  );
}
